import React, { useState } from 'react';
import { StopwatchIcon, LockClosedIcon, CheckIcon } from '@radix-ui/react-icons';
import { GuaranteeModal } from './GuaranteeModal';
import { Button } from '../../components/Button';

import { MONEY_BACK_GUARANTEE_DAYS } from '@bidetny/config';

// other possible colors:
// 1. #ff535c
// 2. #7591eb
// 3. #7dbfda
// 4. #1e2939

export function ReliefSection() {
  const [showGuarantee, setShowGuarantee] = useState(false);
  const onGuaranteeClick = () => setShowGuarantee(true);

  return (
    <section className="py-16" style={{ backgroundColor: '#1e2939' }}>
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-medium text-white text-center mb-12">Installation is low-stress.</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center bg-white rounded-xl p-8 shadow text-blue-900">
            <span className="mb-4"><StopwatchIcon className="w-10 h-10 text-blue-900" /></span>
            <h3 className="text-xl font-bold mb-2">Installation in less than an hour</h3>
            <p className="opacity-90">
              Get your bidet up and running in under 60 minutes—no hassle, no waiting
              <sup className="ml-1">1</sup>
            </p>
          </div>
          <div className="flex flex-col items-center bg-white rounded-xl p-8 shadow text-blue-900">
            <span className="mb-4"><LockClosedIcon className="w-10 h-10 text-blue-900" /></span>
            <h3 className="text-xl font-bold mb-2">Fully insured</h3>
            <p className="opacity-90">Our team is fully insured for your peace of mind and safety</p>
          </div>
          <div className="flex flex-col items-center bg-white rounded-xl p-8 shadow text-blue-900">
            <span className="mb-4"><CheckIcon className="w-10 h-10 text-blue-900" /></span>
            <h3 className="text-xl font-bold mb-2">100% Money-back Guarantee</h3>
            <p className="opacity-90">
              If you’re not satisfied, you get your money back and go back to before
              <sup className="ml-1">2</sup>
            </p>
          </div>
        </div>
        <div className="mt-8 text-white text-sm text-center space-y-2">
          <div>
            <sup>1</sup>
            {' '}
            Usually! Advanced models or unique install conditions can add time
          </div>
          <div>
            <sup>2</sup>
            {' '}
            <Button
              type="button"
              variant="text-light"
              className="underline hover:text-yellow-200 focus:outline-none px-1 py-0.5 text-xs font-normal cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                onGuaranteeClick();
              }}
            >
              Within {MONEY_BACK_GUARANTEE_DAYS} days
            </Button>
          </div>
        </div>
        <GuaranteeModal open={showGuarantee} onClose={() => setShowGuarantee(false)} />
      </div>
    </section>
  );
}
